import React, {Component} from "react";
import {Link} from "react-router-dom";
import {getAgeGroupDiv, hideModal} from "../../util/utility";
import moment from "moment";
import assets from "../../util/assets";
import rightBack from "../../assets/images/Shape.png";
import {Button, Col, Row} from "reactstrap";
import loading_white from "../../assets/gif/loading_white.gif";

export default class AvailabilityDetails extends Component {
    closeModal = () => {
        const modal = document.getElementById("availability-description");
        hideModal(modal);
    };

    render() {
        return (
            <div
                id="availability-description"
                className="modal fade"
                role="dialog"
                aria-labelledby="myModalLabel"
                aria-hidden="true"
            >
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header" style={{margin: "5px auto"}}>
                                <span className="session-details">Session Details</span>
                            </div>
                            <div className="modal-body" style={{textAlign: "left"}}>
                                <div className="row">
                                    <div className="col-9">
                                        <span className="about-session">About Session</span>
                                    </div>
                                    <div className="col-3" style={{textAlign: "right"}}>
                                        <Link
                                            to="/broadcaster/create/availability"
                                            className="mt-2 btn-link session-details-edit-text "
                                            role="button">
                                            EDIT
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-9 sub-text session-details-session-title">
                                        {this.props.availabilityData && this.props.availabilityData.session_title}
                                    </div>
                                    <div className="col-3" style={{marginTop: 14, textAlign: 'right'}}>
                                        {getAgeGroupDiv(this.props.availabilityData && this.props.availabilityData.age_group)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 sub-text session-details-session-description">
                                        {this.props.availabilityData && this.props.availabilityData.session_description}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-9 session-details-session-title">
                                        Session Dates
                                    </div>
                                    <div className="col-6" style={{marginTop: 5}}>
                                        <span className="sub-text font-weight-bold">
                                          Start Time
                                        </span>
                                        <div className="sub-text" style={{textTransform:'uppercase'}}>
                                            {moment.utc(this.props.availabilityData && this.props.availabilityData.availability_start_at).local().format("DD/MM/YYYY  hh:mm a")}
                                        </div>
                                    </div>
                                    <div className="col-6" style={{marginTop: 5}}>
                                        <span className="sub-text font-weight-bold">End Time</span>
                                        <div className="sub-text" style={{textTransform:'uppercase'}}>
                                            {moment.utc(this.props.availabilityData && this.props.availabilityData.availability_end_at).local().format("DD/MM/YYYY  hh:mm a")}
                                        </div>
                                    </div>
                                </div>

                                {
                                    this.props.availabilityData.is_share_stream === 1 &&
                                    <div className="row">
                                        <div className="col-9 session-details-session-title">
                                            Share stream
                                        </div>
                                        {
                                            this.props.availabilityData.facebook_live_url &&
                                            <div className="col-12" style={{marginTop: 5}}>
                                                <div className="sub-text font-weight-bold">
                                                    Facebook stream url
                                                </div>
                                                <div className="sub-text">
                                                    {this.props.availabilityData.facebook_live_url}
                                                </div>
                                            </div>
                                        }

                                        {
                                            this.props.availabilityData.youtube_live_url &&
                                            <div className="col-12" style={{marginTop: 5}}>
                                                <div className="sub-text font-weight-bold">
                                                    Youtube stream url
                                                </div>
                                                <div className="sub-text">
                                                    {this.props.availabilityData.youtube_live_url}
                                                </div>
                                            </div>
                                        }

                                    </div>
                                }

                                <div className="row">
                                    <div className="col-9 session-details-session-title">
                                        Sessions Allowed
                                    </div>
                                </div>

                                {
                                    this.props.availabilityData && this.props.availabilityData.one_to_one_session_allow && (
                                        <Row
                                            className="mt-2 mx-md-0 p-2"
                                            style={{
                                                backgroundColor: "#f7f7f7",
                                            }}
                                            onClick={()=>{
                                                this.props.setActiveTab("1")
                                            }}
                                        >
                                            <Col
                                                md="8"
                                                sm="8"
                                                className="text-left"
                                                style={{marginTop: "5px"}}
                                            >
                                                <img
                                                    src={assets.one_to_one_icon_blue_bg}
                                                    style={{width: "33px"}}
                                                    className="mr-md-2"
                                                />
                                                <span
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: "#58595B",
                                                    }}
                                                >
                        One To One Session
                      </span>
                                                <span className="text-primary font-weight-bold ml-2">
                        {this.props.availabilityData && this.props.availabilityData.one_to_one_session_price ==
                        0
                            ? "Free"
                            : `£${
                            this.props.availabilityData && this.props.availabilityData
                                .one_to_one_session_price / 100
                                } p/min`}
                      </span>
                                            </Col>
                                            <Col md="4" sm="4" className="text-right">
                      <span
                          style={{
                              background: "#E55555",
                              borderRadius: "50%",
                              color: "white",
                              height: "24px",
                              width: "24px",
                              verticalAlign: "middle",
                              display: "inline-block",
                              fontFamily: "Open Sans",
                              fontSize: "12px",
                              fontWeight: "600",
                              letterSpacing: "-1px",
                              lineHeight: "23px",
                              textAlign: "center",
                          }}
                      >
                        {
                            this.props.oneToOneRequests && this.props.oneToOneRequests.length
                        }
                      </span>
                                                <Button color="link" className="text-right" active>
                                                    <img src={rightBack}/>
                                                </Button>
                                            </Col>
                                        </Row>
                                    )}
                                <Row
                                    className="mt-2 mx-md-0 p-2"
                                    style={{
                                        //margin: "0 auto",
                                        //marginTop: "15px",
                                        backgroundColor: "#f7f7f7",
                                    }}
                                    onClick={()=>{
                                        this.props.setActiveTab("2")
                                    }}
                                >
                                    <Col
                                        md="8"
                                        sm="8"
                                        className="text-left"
                                        style={{marginTop: "5px"}}
                                    >
                                        <img
                                            src={assets.group_icon_blue_bg}
                                            style={{width: "33px"}}
                                            className="mr-md-2"
                                        />
                                        <span
                                            style={{
                                                fontSize: 14,
                                                fontWeight: 600,
                                                color: "#58595B",
                                            }}
                                        >
                      Group Session
                    </span>
                                        <span className="text-primary font-weight-bold ml-2">
                      {this.props.availabilityData && this.props.availabilityData.group_session_price === 0
                          ? "Free"
                          : `£${
                          this.props.availabilityData && this.props.availabilityData.group_session_price /
                          100
                              } p/min`}
                    </span>
                                    </Col>
                                    <Col md="4" sm="4" className="text-right">
                    <span
                        style={{
                            background: "#E55555",
                            borderRadius: "50%",
                            color: "white",
                            height: "24px",
                            width: "24px",
                            verticalAlign: "middle",
                            display: "inline-block",
                            fontFamily: "Open Sans",
                            fontSize: "12px",
                            fontWeight: "600",
                            letterSpacing: "-1px",
                            lineHeight: "23px",
                            textAlign: "center",
                        }}
                    >
                      {
                          this.props.groupRequests && this.props.groupRequests.length
                      }
                    </span>
                                        <Button color="link" className="text-right" active>
                                            <img src={rightBack}/>
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <div className="modal-footer mt-3">
                                <div
                                    className="row"
                                    style={{
                                        marginTop: 50,
                                        margin: "0 auto",
                                        justifyContent: "center",
                                    }}
                                >
                                    <div className="col-5">
                                        <button className="btn btn-outline-primary session-details-btn"
                                                onClick={() => this.closeModal()}>
                                            CLOSE
                                        </button>
                                    </div>
                                    <div className="col-5">
                                        {
                                            this.props.isFetching ?
                                                <button className="btn btn-primary session-details-btn"
                                                        onClick={() => {
                                                        }}>
                                                    <img
                                                        src={loading_white}
                                                        alt={"Loading"}
                                                        width={26}
                                                        height={26}
                                                    />
                                                </button>
                                                :
                                                <button className="btn btn-primary session-details-btn"
                                                        onClick={() => this.props.getAllRequestForBroadcast()}>
                                                    VIEW ALL REQUESTS
                                                </button>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
